import { AlertPriority } from '@watcherr/resources';
import flatten from 'lodash/flatten';
import { t } from '~/i18n';

export const declineReasons = [
  {
    value: 'attending-other',
    label: t('alert.decline.options.attendingOther'),
  },
  {
    value: 'toilet',
    label: t('alert.decline.options.toilet'),
  },
  {
    value: 'lunch',
    label: t('alert.decline.options.lunch'),
  },
  {
    value: 'break',
    label: t('alert.decline.options.break'),
  },
  {
    value: 'smoking',
    label: t('alert.decline.options.smoking'),
  },
];

export const fallReasons = [
  {
    value: 'Fall from toilet',
    label: t('alert.resolve.fallOptions.fromToilet'),
  },
  {
    value: 'Fall from bed',
    label: t('alert.resolve.fallOptions.fromBed'),
  },
  {
    value: 'Fall from sainitair',
    label: t('alert.resolve.fallOptions.fromSanitair'),
  },
  {
    value: 'Fall from couch',
    label: t('alert.resolve.fallOptions.fromCouch'),
  },
  {
    value: 'Fall from chair',
    label: t('alert.resolve.fallOptions.fromChair'),
  },
  {
    value: 'Fall from stairs',
    label: t('alert.resolve.fallOptions.fromStairs'),
  },
];

export const resolveReasons = {
  [AlertPriority.Manual]: [
    {
      value: 'planned-treatment',
      label: t('alert.resolve.options.plannedTreatment'),
      type: 'resolve',
    },
    {
      value: 'accidental-press',
      label: t('alert.resolve.options.accidentalPress'),
      type: 'resolve',
    },
    {
      value: 'patient-care',
      label: t('alert.resolve.options.patientCare'),
      type: 'resolve',
    },
    {
      value: 'mobility-assistance',
      label: t('alert.resolve.options.mobilityAssistance'),
      type: 'resolve',
    },
    {
      value: 'undetected-fall',
      label: t('alert.resolve.options.undetectedFall'),
      type: 'resolve',
    },
  ],
  default: [
    {
      value: 'nature-of-call-resolved',
      label: t('alert.resolve.options.natureResolved'),
      type: 'resolve',
    },
    {
      value: 'false-alert',
      label: t('alert.resolve.options.falseAlert'),
      type: 'resolve',
    },
  ],
};

export const translateResolveReason = (reasonString: string) => {
  const reasons = flatten(Object.values(resolveReasons));
  const actioin = reasons.find((reason) => reason.value === reasonString);
  return actioin?.label ?? reasonString;
};
export const translateRejectReason = (reasonString: string) => {
  const reasons = flatten(Object.values(declineReasons));
  const action = reasons.find((reason) => reason.value === reasonString);
  return action?.label ?? reasonString;
};
